import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import { PinViewer } from '../pin.component';
import { ClickDisplay } from '../../../map.component';
import { tap, flatMap } from 'rxjs/operators';
import { APITypes } from '../../../../../commons/global';

const Cesium = (<any>window).Cesium

export class Attribute {
  key: string;
  value: string;
}

@Component({
  selector: 'pp-comp',
  templateUrl: './pp.component.html',
  styleUrls: ['../../../map_commons.scss','../pin.component.scss','./pp.component.scss']
})
export class PPViewer extends PinViewer{
  
  dragging:boolean
  imageLoading:boolean
  loading:boolean
  rand:number

  // if this component becomes active, what's its name?
  activeTab(){
    return 'pp'
  }

  onAnnotationLoaded( isCreate:boolean = false ){
    super.onAnnotationLoaded(isCreate)
    this.mapComp.inspectorComp.setSelected(this.annotation,true, 'PP')
  }

    clickedMap(movement: any, rightClick: boolean, checkedPosition):ClickDisplay{
      console.log ( 'agronomeye.comp :: clickedMap()');
      return this.mapComp.agroComp.clickedMap(movement,rightClick, checkedPosition)
    }
    dragOver(e: DragEvent) {
      e.preventDefault()
      this.dragging = true
      return false
    }
    onDrop(e:DragEvent) {
      if (e.stopPropagation)
        e.stopPropagation()
  
      e.preventDefault()
      this.imageLoading = true
      if(e.dataTransfer.files.length == 1 && 
        (e.dataTransfer.files[0].name.toLowerCase().endsWith('jpg') || 
        e.dataTransfer.files[0].name.toLowerCase().endsWith('png') ||
        e.dataTransfer.files[0].name.toLowerCase().endsWith('jpeg'))
      ){
        fetch(this.annotation.file('image.png'), {
            body:e.dataTransfer.files[0],
            method:'POST'
          }
        ).then(
          response => response.json()
        ).then(r => {
          if(r.status && r.status < 400){
            this.rand = Math.random()
            this.annotation['hasImage'] = true
            this.annotation.saveObservable().subscribe(s => {
              this.openSnackBarInfo('MAP.FILE_UPLOAD')
              this.imageLoading = false
            },
              e => {
                delete this.annotation['hasImage'] 
                this.openSnackBarError('MAP.UPLOAD_ERROR')
                this.imageLoading = false
              }
            )
          } 
          else{
            this.imageLoading = false
            this.openSnackBarError('MAP.UPLOAD.ERROR')
          }

        })
      }
      else{
        this.openSnackBarError('MAP.FILE_IMAGES')
      }
      console.log(e)
      this.dragging = false
      return false
    }
    nukeImage(){
      this.openConfirmDelete(() => {
          this.annotation.vasat.api('/api/Annotation/' + this.annotation.id + '/image.png','delete').pipe(
            tap(s => 
              delete this.annotation['hasImage'] 
            ),
            flatMap( _ => 
              this.annotation.saveObservable()
            )
        ).subscribe(
          r => this.openSnackBarInfo('MAP.FILE.REMOVE'),
          e => this.openSnackBarError('MAP.FILE.ERROR')
        )
      },'Image')
    }

   
}
